import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Ideas } from "../../components/ideas/ideas.component"
import { NoIdeaFound } from "../../components/noIdeaFound/noIdeaFound.component"
import { getTopIdeas } from "../../services/ideas.service"

export const TopIdeasList = () => {
    const [feeds, setFeeds] = useState([])
    const selectedEmpId = useSelector(state => state.topEmployeesIdeas.id)

    const getData = async () => {
        const { status, data } = await getTopIdeas(selectedEmpId)
        if (status == 200) {
            setFeeds(data);
        }
    };
    useEffect(() => {
        getData()
    }, [selectedEmpId])
    return (
        <>
            <h4>TOP IDEAS LEADERBOARD</h4>
            {feeds.length ? feeds.map((data) => {
                return <Ideas key={data.IDEA_ID} ideaId={data.IDEA_ID} Name={data.EMP_NAME} Desc={data.IDEA_DETAIL} CreatedAt={data.CREATEDAT} Attachments={data.attachments} hearts={data.hearts} likes={data.likes} dislikes={data.dislikes} comments={data.comments} reactionId={data.reactionId} reactionType={data.reactionType} />
            }) : <NoIdeaFound/>}
        </>
    )
}